import AreaChart from "@/classes/AreaChart";
import BarChart from "@/classes/BarChart";
import BoxPlot from "@/classes/BoxPlot";
import BubbleChart from "@/classes/BubbleChart";
import BulletChart from "@/classes/BulletChart";
import ColumnChart from "@/classes/ColumnChart";
import ComboBarLineChart from "@/classes/ComboBarLineChart";
import ComboColumnLineChart from "@/classes/ComboColumnLineChart";
import DoughnutChart from "@/classes/DoughnutChart";
import DumbbellPlot from "@/classes/DumbbellPlot";
import DumbbellPlotHorizontal from "@/classes/DumbbellPlotHorizontal";
import FunnelChart from "@/classes/FunnelChart";
import GroupedBarChart from "@/classes/GroupedBarChart";
import GroupedColumnChart from "@/classes/GroupedColumnChart";
import HeatMap from "@/classes/HeatMap";
import Hierarchy from "@/classes/Hierarchy";
import LineChart from "@/classes/LineChart";
import LineSeriesChart from "@/classes/LineSeriesChart";
import LollipopChart from "@/classes/LollipopChart";
import MapChart from "@/classes/MapChart";
import NestedDoughnutChart from "@/classes/NestedDoughnutChart";
import StackedArea100Chart from "@/classes/StackedArea100Chart";
import StackedBar100Chart from "@/classes/StackedBar100Chart";
import StackedBarChart from "@/classes/StackedBarChart";
import StackedColumn100Chart from "@/classes/StackedColumn100Chart";
import StackedColumnChart from "@/classes/StackedColumnChart";
import StreamChart from "@/classes/StreamChart";
import WaffleChart from "@/classes/WaffleChart";
import YearOverYearLineChart from "@/classes/YearOverYearLineChart";

interface ChartComponentConfig {
  chartClass: unknown;
  chartOptions?: {
    seriesType?: string;
    showBullets?: boolean;
    isHorizontal?: boolean;
  };
}

export default <Record<string, ChartComponentConfig>>{
  areaChart: {
    chartClass: AreaChart,
  },
  barChart: {
    chartClass: BarChart,
  },
  boxPlot: {
    chartClass: BoxPlot,
    chartOptions: { isHorizontal: false },
  },
  boxPlotHorizontal: {
    chartClass: BoxPlot,
    chartOptions: { isHorizontal: true },
  },
  bubbleChart: {
    chartClass: BubbleChart,
  },
  bulletChart: {
    chartClass: BulletChart,
  },
  columnChart: {
    chartClass: ColumnChart,
  },
  comboBarLineChart: {
    chartClass: ComboBarLineChart,
    chartOptions: { seriesType: "SmoothedXLineSeries", showBullets: true },
  },
  comboColumnLineChart: {
    chartClass: ComboColumnLineChart,
    chartOptions: { seriesType: "SmoothedXLineSeries", showBullets: true },
  },
  doughnutChart: {
    chartClass: DoughnutChart,
  },
  dumbbellPlot: {
    chartClass: DumbbellPlot,
  },
  dumbbellPlotHorizontal: {
    chartClass: DumbbellPlotHorizontal,
  },
  funnelChart: {
    chartClass: FunnelChart,
  },
  groupedBarChart: {
    chartClass: GroupedBarChart,
  },
  groupedColumnChart: {
    chartClass: GroupedColumnChart,
  },
  heatMap: {
    chartClass: HeatMap,
  },
  lineChart: {
    chartClass: LineChart,
    chartOptions: { seriesType: "SmoothedXLineSeries", showBullets: true },
  },
  lineSeriesChart: {
    chartClass: LineSeriesChart,
    chartOptions: { seriesType: "SmoothedXLineSeries", showBullets: true },
  },
  lollipopChart: {
    chartClass: LollipopChart,
  },
  nestedDoughnutChart: {
    chartClass: NestedDoughnutChart,
  },
  packedCircleChart: {
    chartClass: Hierarchy,
  },
  pieChart: {
    chartClass: DoughnutChart,
  },
  scatterPlot: {
    chartClass: BubbleChart,
  },
  stackedArea100Chart: {
    chartClass: StackedArea100Chart,
  },
  stackedAreaChart: {
    chartClass: StackedArea100Chart,
  },
  stackedBar100Chart: {
    chartClass: StackedBar100Chart,
  },
  stackedBarChart: {
    chartClass: StackedBarChart,
  },
  stackedColumn100Chart: {
    chartClass: StackedColumn100Chart,
  },
  stackedColumnChart: {
    chartClass: StackedColumnChart,
  },
  stepLineChart: {
    chartClass: LineChart,
    chartOptions: { seriesType: "StepLineSeries", showBullets: false },
  },
  stepLineSeriesChart: {
    chartClass: LineSeriesChart,
    chartOptions: { seriesType: "StepLineSeries", showBullets: false },
  },
  streamChart: {
    chartClass: StreamChart,
  },
  mapChart: {
    chartClass: MapChart,
  },
  treeMap: {
    chartClass: Hierarchy,
  },
  waffleChart: {
    chartClass: WaffleChart,
  },
  yearOverYearLineChart: {
    chartClass: YearOverYearLineChart,
    chartOptions: {
      seriesType: "SmoothedXLineSeries",
      showBullets: true,
    },
  },
  yearOverYearStepLineChart: {
    chartClass: YearOverYearLineChart,
    chartOptions: {
      seriesType: "StepLineSeries",
      showBullets: false,
    },
  },
};
